import { mutatorAction } from "satcheljs";
import getStore from "../store";

const setNeedsReplyCountMutator: (count: number) => void = mutatorAction("setNeedsReplyCount", (count: number): void => {
    getStore().needsReplyCount = count;
});

export default setNeedsReplyCountMutator;
